import { useMemo } from "react"
import { Box, Stack, useTheme } from "@mui/material"
import { Link } from "react-router-dom"
import { PromotionCard } from "components/domains/promotions"
import { EmptyData } from "components/EmptyData"
import { useTranslation } from "providers/i18n"
import { PercentIcon } from "components/icons"
import { Head } from "components/Head"
import { usePromotion } from "hooks/promotion/usePromotion"
import { getIcon } from "utils/icon"

export const Promotions = () => {
  const { t } = useTranslation()

  const { storePromotions } = usePromotion()

  const theme = useTheme()
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.promotions) || <PercentIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`PromotionPage`] || {}
  const { emptyDataContainer } = styleOverrides

  return (
    <>
      <Head title={t("Promotions")} />
      <Stack spacing={2}>
        {storePromotions && storePromotions.length > 0 ? (
          storePromotions.map((promotion) => (
            <Link to={`/promotions/${promotion.id}`} key={promotion.id}>
              <PromotionCard size="medium" promotion={promotion} />
            </Link>
          ))
        ) : (
          <Box sx={emptyDataContainer}>
            <EmptyData
              icon={emptyIcon}
              primary={t("Coming soon")}
              secondary={t("Stay tuned for the update")}
            />
          </Box>
        )}
      </Stack>
    </>
  )
}
